module.exports = __webpack_public_path__ + "static/media/MK2_front.e250494d.png";